"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.lightGray = exports.gray = exports.black = void 0;
var _styledComponents = require("styled-components");
var _index = _interopRequireDefault(require("./index.styled"));
const black = exports.black = (0, _styledComponents.css)`
  background: #000;
  ${_index.default.Divider} {
    background-color: #3A3B3C;
  }
`;
const white = exports.white = (0, _styledComponents.css)`
  background: #fff;
`;
const lightGray = exports.lightGray = (0, _styledComponents.css)`
  background: #eaeaea;
`;
const gray = exports.gray = (0, _styledComponents.css)`
  background: #3A3B3C;
`;